import React from "react";
import { Lock } from "lucide-react";
import { useAuth } from "../lib/auth";

export const JURISDICTION_OPTIONS = [
    { value: "eu", label: "EU" },
    { value: "turkiye", label: "Türkiye", pro: true },
    { value: "compared", label: "EU + Türkiye", pro: true },
];

export function useTurkiyeAllowed() {
    const { user } = useAuth();
    return ["professional", "team"].includes(user?.plan_key);
}

export default function JurisdictionSelect({ value, onChange, testId = "jurisdiction-select", label = "Jurisdiction" }) {
    const allowed = useTurkiyeAllowed();
    return (
        <div className="flex items-center gap-2 shrink-0" data-testid={`${testId}-group`}>
            <span className="text-[10px] uppercase tracking-[0.22em] text-[#0D1B3E]/60">
                {label}
            </span>
            <div className="inline-flex border border-[#0D1B3E]/20 bg-white shrink-0">
                {JURISDICTION_OPTIONS.map((o) => {
                    const locked = o.pro && !allowed;
                    return (
                        <button
                            key={o.value}
                            type="button"
                            disabled={locked}
                            onClick={() => onChange(o.value)}
                            title={
                                locked
                                    ? "The Türkiye jurisdiction layer is available on the Professional and Team plans"
                                    : o.value === "compared"
                                      ? "EU and Türkiye compared; weighted as a heavy feature (3 credits)"
                                      : o.pro
                                        ? "Turkish law grounded in official sources via live search"
                                        : "EU law from the primary-source corpus"
                            }
                            data-testid={`${testId}-option-${o.value}`}
                            className={`min-h-[44px] px-3 text-xs font-semibold tracking-wide transition-colors whitespace-nowrap inline-flex items-center gap-1 ${
                                value === o.value
                                    ? "bg-[#0D1B3E] text-[#F5F0E8]"
                                    : locked
                                      ? "text-[#0D1B3E]/35 cursor-not-allowed"
                                      : "text-[#0D1B3E]/80 hover:bg-[#0D1B3E]/5"
                            }`}
                        >
                            {o.label}
                            {locked && <Lock size={10} />}
                        </button>
                    );
                })}
            </div>
        </div>
    );
}

export function TurkiyeNotice({ jurisdiction, className = "" }) {
    if (!jurisdiction || jurisdiction === "eu") return null;
    return (
        <p
            className={`text-[11px] leading-snug text-[#0D1B3E]/65 ${className}`}
            data-testid="turkiye-notice"
        >
            Turkish answers are verified against official sources (mevzuat.gov.tr,
            Resmi Gazete, court and authority databases) via live search. This is
            legal information, not legal advice; EuroLaw Hub does not provide
            Turkish legal advice from a locally licensed advocate (avukat).
        </p>
    );
}
